export default "__VITE_PUBLIC_ASSET__9c3c7ee8__"